import { Injectable } from '@angular/core';
import { MenuType } from 'src/app/app.menu';
import { RootModuleType } from 'src/app/models/root-module.model';
import { ApiService } from 'src/app/services/api.service';
import { AccessRulesService } from '../../app/services/access-rules.service';
import { ScreenService } from './screen.service';

export interface MenuItem {
  materialIcon?: string;
  imgIcon?: string;
  imgIconHover?: string;
  text: string;
  route?: string;
  modal?: { component: any; config: any };
  activeLinks?: string[];
  activeBy?: {
    path: string;
    afterPaths: string[];
    doesNotInclude?: string;
  }[];
  cssClass?: string;
  callback?: any;
  rootModule?: RootModuleType;
  type: MenuType;
  subMenu?: MenuItem[];
  enable?: boolean;
}

@Injectable()
export class MenuService {
  items: MenuItem[];

  isMinimized: boolean;

  constructor(
    public screenService: ScreenService,
    private apiService: ApiService,
    private accessRulesService: AccessRulesService,
  ) {
    screenService.resize$.subscribe(() => {
      this.isMinimized = !screenService.isLarge();
    });
  }

  toggleMenu(): void {
    this.isMinimized = !this.isMinimized;
  }

  getPLEXTERALink(params: { email: string; firstName: string; lastName: string }) {
    return this.apiService.post('plextera/auth-user/sso', params);
  }

  getAccessRulesByType(type: string, items: MenuItem[], parentAccessRules?: any): any | null {
    let accessRulesChain = [...(parentAccessRules ?? [])];
    for (const item of items) {
      if (this.accessRulesService.getAccessRulesValue().menu[item.type]) {
        accessRulesChain.push(this.accessRulesService.getAccessRulesValue().menu[item.type]);
      }
      if (item.type === type) {
        return accessRulesChain;
      }
      if (item.subMenu) {
        const result = this.getAccessRulesByType(type, item.subMenu, accessRulesChain);

        if (result) {
          return result;
        }

        accessRulesChain = [];
      }

      accessRulesChain = [];
    }
    return null;
  }
}
